module.exports = __webpack_public_path__ + "assets/images/magazine-gt_5735f3a3edc2e350295d8f5c58c4a5b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/magazine-gt.png
// module id = 260
// module chunks = 0